import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import tw from "twin.macro";
import { useTranslation } from "react-i18next";

import Header from "../../../components/headers/light.js";
import DesignIllustration from "../../../images/img/onas_1.png";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const Container = styled.div`
    ${tw`relative`}
    background-color: #e2ffe2;
`;

const TwoColumn = tw.div`flex flex-col lg:flex-row lg:items-center max-w-screen-xl mx-auto py-2 md:py-2`;
const LeftColumn = tw.div`relative lg:w-6/12 text-center max-w-lg mx-auto lg:max-w-none lg:text-left`;
const RightColumn = tw.div`relative mt-12 lg:mt-0 flex-1 flex flex-col justify-center lg:self-end`;

const Heading = styled.h1`
    ${tw`font-bold text-3xl md:text-3xl lg:text-4xl xl:text-5xl  leading-tight`}
    margin-bottom: 20px;
`;

const Paragraph = tw.p`my-2 lg:my-4 text-base xl:text-lg`;

const Actions = styled.div`
    ${tw`relative max-w-md text-center mx-auto lg:mx-0`}
    button {
        ${tw`w-[220px] sm:absolute right-0 top-0 bottom-0 bg-green-500 text-white font-bold my-4 sm:my-2 rounded-full py-5 flex items-center justify-center sm:leading-none focus:outline-none transition duration-300`}
        background-color: #0ABD19;
        border: none;
        margin-right: 220px;
        cursor: pointer;
    }

    button:hover,
    button:focus {
        transform: scale(1.1);
    }
`;

const IllustrationContainer = styled.div`
    ${tw`flex justify-center lg:justify-end items-center`}
    img {
        width: auto;
        height: auto;
    }
`;

export default ({ roundedHeaderButton }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [user, setUser] = useState(null);
    const auth = getAuth();

    // Отслеживаем состояние авторизации
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
        });

        return () => unsubscribe();
    }, [auth]);

    const handleGetAddressClick = () => {
        console.log('🔘 Button clicked, user:', user);

        if (user) {
            console.log('✅ User authorized, redirecting to PersonalArea');
            navigate("/PersonalArea");
        } else {
            console.log('❌ User not authorized, redirecting to Login');
            navigate("/Login");
        }
    };

    return (
        <>
            <Header roundedHeaderButton={roundedHeaderButton} />
            <Container>
                <TwoColumn>
                    <LeftColumn>
                        <Heading>{t("mainPage.heading")}</Heading>
                        <Paragraph>{t("mainPage.paragraph")}</Paragraph>
                        <Actions>
                            <button onClick={handleGetAddressClick}>{t("mainPage.button")}</button>
                        </Actions>
                    </LeftColumn>
                    <RightColumn>
                        <IllustrationContainer>
                            <img
                                tw="min-w-0 w-11/12 max-w-lg xl:max-w-3xl"
                                src={DesignIllustration}
                                alt="Design Illustration"
                            />
                        </IllustrationContainer>
                    </RightColumn>
                </TwoColumn>
            </Container>
        </>
    );
};
